import React from "react";
import "./HomeSec1.css";
const HomeSec1 = () => {
  return (
    <div>
      <div>
        <div className="container-fluid main ">
          <div className="row">
            <div className="col-2 "></div>
            <div className="col-8 text-center ">
              <div className="row">
                <div className="container m">
                  <img className="logo-3" src="./bg-2.png" alt="hhh" />
                </div>
              </div>
              <div className="row">
                <div className="container-fluid mm">
                  <img className="line-" src="./line-1.png" alt="hhh" />
                </div>
              </div>
              <div className="row">
                <div className="container  n">
                  <span className="para-1">Welcome to</span>
                </div>
                <div className="container nn">
                  <span className="para_2">The Surya Vilas Palace</span>
                  <img className="img-1" src="./image 429.png" alt="hhh" />
                </div>
                <div className="container nnn">
                  <p className="para-3">
                    Lorem ipsum dolor sit amet consectetur. Adipiscing lectus
                    sit sit sed semper vitae faucibus consequat. Sed dui auctor
                    aliquam quam urna magna feugiat egestas placerat. Pharetra
                    arcu nulla lacus molestie quis dignissim quis tempor
                    interdum. Quam blandit iaculis ante pellentesque lectus
                    viverra tristique ultrices. Adipiscing purus mattis leo sit
                    mi id sed. Eleifend sed enim odio sapien tincidunt viverra.
                    Interdum congue eu bibendum tellus odio. Ridiculus posuere
                    ut id imperdiet lorem Lorem ipsum dolor sit amet
                    consectetur. Adipiscing lectus sit sit sed semper vitae
                    faucibus consequat. Sed dui auctor aliquam quam urna magna
                    feugiat egestas placerat. Pharetra arcu nulla lacus molestie
                    quis dignissim quis tempor interdum.{" "}
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="container o">
                  <img className="line-2" src="./line-1.png" alt="hhh" />
                </div>
              </div>
              <div className="row">
                <div className="container oo">
                  <img className="img-3" src="./bg-3.png" alt="hhh" />
                </div>
              </div>
            </div>

            <div className="col-2"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeSec1;
